import Avatar from './Avatar';
import Image from './Image';

export default {
  Avatar,
  Image,
};
